import getWithToken from './base/get-with-token'

const getDeviceEvents = () => getWithToken(`/dashboard/get-device-event-data`)()

export default getDeviceEvents